<template>
  <div class="side-frame-warning">
    <span style="font-size: 14px; color: #606266">{{
      this.$l('table_scm_name') || '工厂'
    }}</span>
  </div>
</template>
<script>
// 初始表单

export default {
  props: {},
  data() {
    return {}
  },
  mounted() {
    this.query()
  },
  methods: {
    query() {
      this.$emit('query')
    },
  },
}
</script>
